// extracted by mini-css-extract-plugin
export default {"dhcpConfigRow":"dhcpConfig_dhcpConfigRow__ttTY7"};